import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '@hq-core/models/app-settings';
import { DataResource } from '@hq-custom-types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BrandProduct } from '../models/brand-product';

@Injectable({ providedIn: 'root' })
export class BrandProductResource implements DataResource<BrandProduct> {
    private readonly baseUrl: string;

    constructor(
        private http: HttpClient,
        private appSettings: AppSettings,
    ) {
        this.baseUrl = this.appSettings.apis.vendorData;
    }

    getAll(brandId: string): Observable<Array<BrandProduct>> {
        return this.http.get<Array<BrandProduct>>(`${this.baseUrl}/brand-products/${brandId}`);
    }

    patch(sourceBrandId: number, targetBrandId: number, itemIds: number[]): Observable<boolean> {
        return this.http.patch<void>(
            `${this.baseUrl}/brand-products/${sourceBrandId}`,
            { targetBrandId, itemIds },
        ).pipe(map(() => true));
    }
}
